module.exports = __webpack_public_path__ + "img/video-poster.da9ab3b0.png";